const NUMBER_DECIMALS = 6;

const parseNumber = (raw) => {
  if (raw == null) return null;
  const normalized = String(raw).replace(",", ".").trim();
  if (normalized === "") return null;
  const value = Number(normalized);
  if (!Number.isFinite(value)) return null;
  return value;
};

const formatNumber = (value) => {
  if (!Number.isFinite(value)) return "";
  const fixed = value.toFixed(NUMBER_DECIMALS);
  // Trim trailing zeros and optional dot.
  return fixed.replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");
};

const recalcPair = (sourceInput, targetInput) => {
  const sourceValue = parseNumber(sourceInput.value);
  const kfc = parseNumber(sourceInput.dataset.kfc);

  if (sourceValue == null || kfc == null) {
    targetInput.value = "";
    return;
  }

  const result = sourceValue * kfc;
  targetInput.value = formatNumber(result);
};

const initCalc = (calcEl) => {
  const inputs = calcEl.querySelectorAll(".calc-input__input");
  if (inputs.length !== 2) return;

  const [first, second] = inputs;

  // Initial sync: from first to second.
  recalcPair(first, second);

  const onInput = (event) => {
    const source = event.currentTarget;
    const target = source === first ? second : first;
    recalcPair(source, target);
  };

  first.addEventListener("input", onInput);
  second.addEventListener("input", onInput);
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".calc").forEach(initCalc);
});
